"use client"

import { SessionProvider } from "next-auth/react"
import "./globals.css"
import { UserContext } from "./context/UserContext"
import { MessageContext } from "./context/MessageContext"
import { TaskContext } from "./context/TaskContext"
import { ActionContext } from "./context/ActionContext"
import { EmailContext } from "./context/EmailContext"
import { CalendarContext } from "./context/CalendarContext"
import { PersonalAssistantMessageContext } from "./context/PersonalAssistantMessageContext"
import { ToastProvider } from "./context/ToastContext"
import SseConnection from "./components/SseConnection"
import { Toaster } from "./components/common/toaster/Toaster"

// export const metadata: Metadata = {
//   title: "Create Next App",
//   description: "Generated by create next app",
// }

export default function RootLayout({
  children,
}: {
  children: React.ReactNode
}) {
  return (
    <html lang="en">
      <body>
        <SessionProvider>
          <ToastProvider>
            <UserContext>
              <EmailContext>
                <MessageContext>
                  <TaskContext>
                    <ActionContext>
                      <CalendarContext>
                        <PersonalAssistantMessageContext>
                          <SseConnection>
                            {children}
                            <Toaster />
                          </SseConnection>
                        </PersonalAssistantMessageContext>
                      </CalendarContext>
                    </ActionContext>
                  </TaskContext>
                </MessageContext>
              </EmailContext>
            </UserContext>
          </ToastProvider>
        </SessionProvider>
      </body>
    </html>
  )
}
